import { useMemo } from "react";
import { useQuery } from "react-query";

import { useReactAppState } from "../../shared/containers/utils";
import { mlsSeasonsAPI } from "../../shared/api/variables";
import { fetchClient } from "../../shared/api/fetching";
import { getDefaultMlsCompetitionId, isAllOptionSelected } from "../utils";


function useMlsSeasons({ competitionSportecId }) {
    const { apiList } = useReactAppState();

    const competitionId = useMemo(() => {
        const defaultCompetitionSportecId = getDefaultMlsCompetitionId();
        if (isAllOptionSelected(competitionSportecId)) {
            return defaultCompetitionSportecId;
        }

        return competitionSportecId;
    }, [competitionSportecId]);

    const mlsSeasonsEndpoint = mlsSeasonsAPI({ competitionSportecId: competitionId });

    return useQuery({
        queryKey: ["mls-seasons", competitionId],
        queryFn: () => fetchClient({ endpoint: mlsSeasonsEndpoint, apiURL: apiList?.statsAPI }),
        select: response => {
            return new Map(response?.seasons?.map(seasonItem => [seasonItem.season, seasonItem]));
        },
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
        enabled: !!competitionSportecId,
    });
}

export default useMlsSeasons;
